import { all, fork } from "redux-saga/effects";

import { pinsSaga } from "./pins";
import { recordsSaga } from "./records";
import { stopVisualsSaga } from "./stopVisuals";
import { toolsSaga } from "./tools";

export function* mapSaga() {
  yield all([fork(pinsSaga), fork(toolsSaga), fork(recordsSaga), fork(stopVisualsSaga)]);
}
